import React, { createContext, useContext, useState, ReactNode } from 'react';

interface WidthContextType {
  isFullWidth: boolean;
  toggleWidth: () => void;
}

const WidthContext = createContext<WidthContextType | undefined>(undefined);

export const WidthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isFullWidth, setIsFullWidth] = useState(true); // Default to true for full width

  const toggleWidth = () => {
    setIsFullWidth(!isFullWidth);
  };

  return (
    <WidthContext.Provider value={{ isFullWidth, toggleWidth }}>
      {children}
    </WidthContext.Provider>
  );
};

export const useWidth = () => {
  const context = useContext(WidthContext);
  if (context === undefined) {
    throw new Error('useWidth must be used within a WidthProvider');
  }
  return context;
};
